module.exports = __webpack_public_path__ + "static/img/jiaotong.b3ce660a.png";